import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import {getCustomerLoyaltyState, getSocialAuth} from '../../+state/stores.selectors';
import { CustomerLoyalty } from 'src/app/stores/stores';
import {LoadCustomerLoyalty} from "../../+state/stores.actions";

@Component({
  selector: 'app-profile-loyalty-points',
  templateUrl: './profile-loyalty-points.component.html',
  styleUrl: './profile-loyalty-points.component.scss',
})
export class ProfileLoyaltyPointsComponent implements OnInit, OnDestroy {
  customerLoyalty: CustomerLoyalty;
  customerLoyaltyStatus: string;

  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.store
      .select(getCustomerLoyaltyState)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((customerLoyaltyState) => {
        this.customerLoyalty = customerLoyaltyState.data;
        this.customerLoyaltyStatus = customerLoyaltyState.status;
      });

    this.store
      .select(getSocialAuth)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((socialAuth) => {
        if (socialAuth?.socialLoginState?.userId) {
          this.store.dispatch(new LoadCustomerLoyalty({
            src: 'ProfileLoyaltyPointsComponent',
            description: 'Must refetch customer loyalty',
          }));
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
